import { Injectable } from 'angular-ts-decorators';

import { Initable } from '@shared/app/scripts/services/initable';
import { Sales } from '@shared/app/scripts/services/sales';
import { Sentry } from '@shared/app/scripts/services/sentry';

/**
 * Service that manages the things related to creating a new
 * sales/consignments/transits.
 */
@Injectable('salesManager')
export class SalesManager implements Initable {
  /**
   * Next available number for transaction type.
   */
  counters: {
    sales: number;
    consignments: number;
    transits: number;
  } = {
    sales: 1,
    consignments: 1,
    transits: 1,
  };

  constructor(
    private sales: Sales,
    private sentry: Sentry,
  ) {
    'ngInject';
  }

  /**
   * This method initializes counters.
   * @return
   * A promise that resolves with counters value
   */
  init(): ng.IPromise<any> {
    return this.sales.posInit().then(
      (response) => {
        if (response?.counters?.sales) {
          this.counters.sales = response.counters.sales;
        }

        if (response?.counters?.consignments) {
          this.counters.consignments = response.counters.consignments;
        }

        if (response?.counters?.transits) {
          this.counters.transits = response.counters.transits;
        }

        return this.counters;
      },
      () => {
        this.sentry.captureMessage(
          'Failed to initable salesManager correctly! Keeping the current values',
        );

        return this.counters;
      },
    );
  }

  /**
   * Increase the sales counter by 1.
   * @return
   * New value of counter
   */
  incrementSalesCounter() {
    if (!this.counters) {
    }

    return ++this.counters.sales;
  }

  /**
   * Increase the consignments counter by 1.
   * @return
   * New value of counter
   */
  incrementConsignmentsCounter() {
    if (!this.counters) {
      this.sentry.captureMessage('salesManager was not initialized correctly');
      return;
    }

    return ++this.counters.consignments;
  }

  /**
   * Increase the transits counter by 1.
   * @return
   * New value of counter
   */
  incrementTransitsCounter() {
    if (!this.counters) {
      this.sentry.captureMessage('salesManager was not initialized correctly');
    }

    return ++this.counters.transits;
  }
}
